import { action, Action } from 'easy-peasy';
import { forIn } from 'lodash';
import { AIMaterialCreateMode, AIMaterialCreateType } from '@/types';

interface IMaterialStyleType {
    id: number;
    name: string;
    iShow: boolean;
}
export interface IAIMaterialModel {
    showAIMaterialWindow: AIMaterialCreateType.photo | AIMaterialCreateType.bg | null;
    aiMaterialList: {
        url: string;
        id: number;
        bigUrl: string;
        generateType: AIMaterialCreateMode;
        styleType: string;
    }[];

    bgMaterialStyleList: IMaterialStyleType[];

    setBGMaterialStyleList: Action<IAIMaterialModel, IMaterialStyleType[]>;

    photoMaterialStyleList: IMaterialStyleType[];

    setPhotoMaterialStyleList: Action<IAIMaterialModel, IMaterialStyleType[]>;

    setAIMaterialList: Action<
        IAIMaterialModel,
        {
            url: string;
            id: number;
            bigUrl: string;
            generateType: AIMaterialCreateMode;
            styleType: string;
        }[]
    >;
    setShowAIMaterialWindow: Action<IAIMaterialModel, AIMaterialCreateType.photo | AIMaterialCreateType.bg | null>;

    applyLoading: boolean;

    setApplyLoading: Action<IAIMaterialModel, boolean>;

    taskMap: { [key: string]: boolean };

    setTaskMap: Action<IAIMaterialModel, { id: string; isCancel: boolean }>;

    setTaskMapAllTrue: Action<IAIMaterialModel>;

    bgApplyAIInfo: { category_id: string; type: string; url: string } | null;

    setBgApplyAIInfo: Action<IAIMaterialModel, { category_id: string; type: string; url: string } | null>;
}

export const aiMaterialModel: IAIMaterialModel = {
    bgMaterialStyleList: [],

    setBGMaterialStyleList: action((state, bgMaterialStyleList) => {
        state.bgMaterialStyleList = bgMaterialStyleList;
    }),

    photoMaterialStyleList: [],

    setPhotoMaterialStyleList: action((state, photoMaterialStyleList) => {
        state.photoMaterialStyleList = photoMaterialStyleList;
    }),

    showAIMaterialWindow: null,

    setShowAIMaterialWindow: action((state, showAIMaterialWindow) => {
        state.showAIMaterialWindow = showAIMaterialWindow;
    }),

    aiMaterialList: [],

    setAIMaterialList: action((state, aiMaterialList) => {
        state.aiMaterialList = aiMaterialList;
    }),

    applyLoading: false,

    setApplyLoading: action((state, applyLoading) => {
        state.applyLoading = applyLoading;
    }),

    taskMap: {},

    setTaskMap: action((state, task) => {
        state.taskMap[task.id] = task.isCancel;

        state.taskMap = { ...state.taskMap };
    }),

    setTaskMapAllTrue: action((state) => {
        forIn(state.taskMap, (value, key) => {
            state.taskMap[key] = true;
        });

        state.taskMap = { ...state.taskMap };
    }),

    bgApplyAIInfo: null,

    setBgApplyAIInfo: action((state, bgApplyAIInfo) => {
        state.bgApplyAIInfo = bgApplyAIInfo;
    }),
};
